import React from "react";
import {getPdfReport} from "../../api";
import {getPreEngPdfReport} from "../../api/PreEForm";

function formatDate()
{
    let date = new Date();
    let mnth = (date.getMonth() + 1).toString();
    if(mnth.length == 1) mnth = '0' + mnth;
    let dd = (date.getDate()).toString();
    if(dd.length == 1) dd = '0' + dd;
    return date.getFullYear()+'-'+mnth+'-'+dd;
}

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

function downloadToZipFile(response) {

    let pdfData = response? response.pdfReport : [];
    let pdfByteArr = base64ToArrayBuffer(pdfData);
    let filename = response.fileName;
    let fileType = response.fileType;
    downloadToClient(filename, pdfByteArr, fileType);

}

function downloadToClient(reportName, byte, fileType)
{
        let blob = new Blob([byte], {type: "application/" + fileType});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = reportName;
        link.click();
}

export async function downloadFullPdfReport(projectId)
{
    let dateStr = formatDate();
    let response = await getPdfReport(projectId, dateStr);
    downloadToZipFile(response);
}

export async function downloadPreEngPdfReport(projectId, formId)
{
    let dateStr = formatDate();
    let response = await getPreEngPdfReport(projectId, formId, dateStr);
    downloadToZipFile(response);
}